import { UserOutlined } from '@ant-design/icons';
import { Avatar, Tooltip } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import './UserAvatarStyles.less';

interface IUserAvatarProps {
  size?: number;
  firstName?: string | null;
  lastName?: string;
  className?: string;
  email?: string;
}

const UserAvatar: FC<IUserAvatarProps> = ({ size, firstName, lastName, className, email }) => {
  const [intials, setinitials] = useState<string>('');
  useEffect(() => {
    if (firstName && lastName) {
      setinitials(`${firstName.charAt(0)}${lastName.charAt(0)}`);
    }
    if (firstName && !lastName) {
      setinitials(`${firstName.charAt(0)}`);
    }
  }, [firstName, lastName]);

  return (
    <Tooltip title={email}>
      <Avatar size={size || 44} className={`user-avatar ${className} `}>
        {intials ? intials.toUpperCase() : <UserOutlined />}
      </Avatar>
    </Tooltip>
  );
};

export default UserAvatar;
